import { render, staticRenderFns } from "./CUpdateBtn.vue?vue&type=template&id=1ea06440"
import script from "./CUpdateBtn.vue?vue&type=script&lang=js"
export * from "./CUpdateBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea06440')) {
      api.createRecord('1ea06440', component.options)
    } else {
      api.reload('1ea06440', component.options)
    }
    module.hot.accept("./CUpdateBtn.vue?vue&type=template&id=1ea06440", function () {
      api.rerender('1ea06440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CUpdateBtn.vue"
export default component.exports